<template>
  <div class="py-0" style="right: 0; left: 0;">
    <nav class="navbar  navbar-custom py-0" style="position:fixed;top:0;width:100%; z-index:99999;
">
      <b-navbar-toggle target="navbarCustom1"
        ><i class="fa fa-bars fa-lg py-1 text-white"></i
      ></b-navbar-toggle>
      <span class="text-white"><b> Animal Katta Dairy App</b></span>
      <li class="nav-item dropdown" style="">
              <i class="fa fa-power-off text-white fa-lg" @click="logout"></i>
            </li>
      <b-collapse is-nav id="navbarCustom1">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link class="nav-link" to="/home">HOME</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/profile"
              >PROFILE</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/members"
              >MEMBERS</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/register"
              >MILK REGISTER</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/collection"
              >MILK COLLECTION</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/report"
              >MILK COLLECTION REPORT</router-link
            >
          </li>

          <!-- <li class="nav-item">
            <router-link class="nav-link" to="/changepassword"
              >CHANGE PASSWORD</router-link
            >
          </li> -->
          
          <!-- <li class="nav-item">
            <router-link class="nav-link" to="/contactus"
              >CONTACT US</router-link
            >
          </li> -->
          
          
        </ul>

        <!--<span class="ml-auto mr-5">
          <ul class="navbar-nav">
            <li class="nav-brand">
              <a class="nav-link" href="#">WELCOME {{ username }}</a>
            </li>
            <li class="nav-item dropdown" style="border-left: 1px solid #fff">
              <a class="nav-link" href="#" @click="logout">LOGOUT</a>
            </li>
          </ul>
        </span>-->
      </b-collapse>
    </nav>

    <b-modal
      centered
      ref="mdlSNF"
      id="mdlSNF"
      hide-footer
      title=" Are You Sure?"
    >
      <b-form>
        <!-- <b-form-group label="SNF Value">
          <b-input type="number" step="0.1" min="0" max="12"> </b-input>
        </b-form-group> -->
        <b-button
          type="submit"
          variant="success"
          size="sm"
          v-on:click="l_out()"
          style="color:white;background-color:#51c569;"
          >Logout</b-button
        >
      </b-form>
    </b-modal>

    <div class="navbar navbar1 navbar-custom" style="position:fixed;bottom:0;width:100%;z-index:99999;">
   <router-link class="nav-link" to="/home">
   
        <i class="fa fa-home fa-lg" aria-hidden="true"></i><br><span style="text-align:center;">Home</span>
     </router-link>
  <router-link class="nav-link" to="/profile">
  <i class="fa fa-user fa-lg" aria-hidden="true;"></i><br><span>Profile</span> 
  </router-link>
  <router-link class="nav-link" to="/members" >
    <i class="fa fa-users fa-lg" aria-hidden="true;align:center"></i><br><span>Members</span> 
  </router-link>
  <router-link class="nav-link" to="/register">
    <i class="fa fa-calendar fa-lg" aria-hidden="true;"></i><br><span>Register</span> 
  </router-link>
  <router-link class="nav-link" to="/collection">
    <i class="fa fa-id-card fa-lg" aria-hidden="true;"></i><br><span>Entry</span> 
  </router-link>
  <router-link class="nav-link" to="/report">
    <i class="fa fa-table fa-lg" aria-hidden="true;"></i><br><span>Report</span>
  </router-link>
</div>

    <!--<div class="navbar navbar-custom" style="position:fixed;bottom:0;width:100%;z-index:99999;">
  <a href="#">
    <router-link class="nav-link" to="/home"><i class="fa fa-home fa-lg" aria-hidden="true"></i><span style="text-align:center;">Home</span>
    </router-link>
  </a> 
  <a href="#">
    <router-link class="nav-link" to="/profile"><i class="fa fa-user fa-lg" aria-hidden="true;"></i><span>Profile</span></router-link>
  </a> 
  <a href="#">
    <router-link class="nav-link" to="/members" ><i class="fa fa-users fa-lg" aria-hidden="true;align:center"></i><span>Members</span></router-link>
  </a> 
  <a href="#">
    <router-link class="nav-link" to="/register"><i class="fa fa-calendar fa-lg" aria-hidden="true;"></i><span>Register</span></router-link>
  </a>           
  <a href="#">
    <router-link class="nav-link" to="/collection"><i class="fa fa-id-card fa-lg" aria-hidden="true;"></i><span>Entry</span></router-link>
  </a>
             
  <a href="#">
    <router-link class="nav-link" to="/report"><i class="fa fa-table fa-lg" aria-hidden="true;"></i><span>Report</span></router-link>
  </a>
</div>
</div>

     </b-navbar> -->
  </div>
</template>

<script>
export default {
  data() {
    return {username:"",};
  },
  methods: {
    l_out()
    {
      this.$refs["mdlSNF"].hide();
      this.$session.destroy();
      localStorage.clear();
      this.$store.dispatch("logout");
      this.$router.replace("/");
    },
    logout() {
      this.$refs["mdlSNF"].show();
     
    },
    login() {
      this.$router.replace("/");
    },
  },
  computed: {
    //username() {
      //var nme = this.$store.getters.loggedUser;
     // return this.$session.get("username"); //nme.user_name;
    //},
    RoleID() {
      //var role = this.$store.getters.regType;
      return 0;
      //alert(nme.RegistrationType);
    },    
  },
  mounted()
  {
    this.username=this.$session.get("username");
  }
};
</script>

<style scoped>
.navbar {
  width: 100%;
}

.navbar1 a {
    text-align: center;

  align: center;
  text-align:center!important;
  color: white;
  text-decoration: none;
  font-size: 12px;
  align:center;
  width: 16%; /* Four links of equal widths */
  text-align: center;
}

.navbar1 a:hover {
}

.navbar1 a.active {
  background-color: #04AA6D;
}

@media screen and (max-width: 400px) {
  .navbar1 a {
    text-align: center;

  align: center;
  text-align:center!important;
  color: white;
  text-decoration: none;
  font-size: 11px;
  align:center;
  width: 16%; /* Four links of equal widths */
  text-align: center;
  }
  
.navbar-custom {
  background-color: #51c569 !important;
  min-height: 30px;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 400;
  font-stretch: normal;
  font-size: 9px;
  /* line-height: 54px; */
  font-family: "Open sans", sans-serif;
  text-transform: uppercase;
}
  .navbar {
  width: 100%;
}
}
 .inlineList {
   display: flex;
   flex-direction: row;
   /* Below sets up your display method: flex-start|flex-end|space-between|space-around */
   justify-content: flex-start; 
   /* Below removes bullets and cleans white-space */
   list-style: none;
   padding: 0;
   /* Bonus: forces no word-wrap */
   white-space: nowrap;
 }

.navbar-custom {
  background-color: #51c569 !important;
  min-height: 70px;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  /* line-height: 54px; */
  font-family: "Open sans", sans-serif;
  text-transform: uppercase;
}
/* change the brand and text color */
.navbar-custom .navbar-brand,
.navbar-custom .navbar-text {
  color: white;
}
/* change the link color */
.navbar-custom .navbar-nav .nav-link {
  color: white;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  padding-left: 30px;
  text-transform: uppercase;
}

/* change the color of active or hovered links */
.navbar-custom .nav-item.active .nav-link,
.navbar-custom .nav-item:hover .nav-link {
  color: #f4ff60;
  padding-left: 30px;
}

.navbar-custom .dropdown-menu {
  background-color: #51c569 !important;
  margin-left: -50px;
}
.navbar-custom .dropdown-menu-left {
  background-color: #51c569 !important;
  margin-left: 10px !important;
}
.navbar-custom .dropdown-item {
  color: #ffffff;
  height: 40px !important;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  line-height: 34px;
  padding-left: 30px;
  text-transform: uppercase;
}

.dropdown-item a {
  color: #ffffff;
  height: 40px !important;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  line-height: 34px;
  padding-left: 30px;
  text-transform: uppercase;
}
.navbar-custom .dropdown-item:hover,
.navbar-custom .dropdown-item:focus {
  /* color: #333333;
  background-color: rgba(255, 255, 255, 0.5); */
  color: red;
  background-color: white;
  display: block;
}

/* Dropdown Button */
.navbar-custom .dropbtn {
  height: 70px;
  background-color: #2e4b90 !important;
  color: white;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;

  font-family: "Open sans", sans-serif;
  border: none;
  padding-left: 30px;
  text-transform: uppercase;
}

/* The container <div> - needed to position the dropdown content */
.navbar-custom .dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #2e4b90;
  /* min-width: 160px; */
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: white;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #ddd;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn:hover {
  background-color: #f4ff60;
}

.header_aera .navbar-collapse .navbar-nav.navbar-right li a {
  margin-top: -15px;
}

#nav a.router-link-exact-active {
    color: #218838;
}
</style>